<template>
    <div class="Swiper">
        <div class="swiper-style" v-if="!isWaybillsQuery">
            <el-carousel
                trigger="click"
                arrow="always"
                :height="bannerHeight + 'px'"
                @mouseenter.native="isclick = true"
                @mouseleave.native="isclick = false"
                @change="linkTo"
            >
                <el-carousel-item v-for="(item, index) in imgList" :key="index">
                    <img
                        ref="bannerHeight"
                        id="thisImg"
                        class="banner-img"
                        :src="item.productionImgUrl"
                        alt=""
                        @click="clickBuy(item)"
                        :style="{ cursor: item.site ? 'pointer' : '' }"
                        @load="handleLoad"
                    />
                </el-carousel-item>
            </el-carousel>

            <div class="btn">
                <div class="btn-demo onlyFontColorWhite">
                    <div
                        class="btn-demo-item"
                        :class="[
                            {
                                no:
                                    messageerBox == '' &&
                                    historicalData.length == 0,
                            },
                        ]"
                    >
                        <span @click="routerLink1('queryLlist')"
                            >Tracking and Information</span
                        >

                        <div class="zong_in">
                            <!-- <div class="token invalid" v-for="(item,index) in allData" :key="index" :data-value="spans" @dblclick="toggleInputNode(index)">
								<span v-if="selectedOrderIdx !== index" class="token-label" style="max-width: 251px;color: gray;">{{item}}</span>
								<a v-if="selectedOrderIdx !== index" @click="delet(index)" href="#" class="close" tabindex="-1">×</a>
								<el-input ref="order_input" v-if="selectedOrderIdx === index" v-model="allData[selectedOrderIdx]" @blur="selectedOrderIdx = ''"></el-input>
							</div> -->
                            <el-input
                                @blur="blurHandle"
                                oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')"
                                v-model="input"
                                placeholder="Enter tracking number E.g. EE15080001XCH"
                            >
                                <template slot="suffix">
                                    <i
                                        class="el-icon-search"
                                        @click="routerLink1('queryLlist')"
                                    ></i>
                                    <span
                                        class="search-btn"
                                        @click="routerLink1('queryLlist')"
                                        style="cursor: pointer"
                                        >Track</span
                                    >
                                    <span class="notice">{{
                                        phonePrompt
                                    }}</span>
                                </template>
                            </el-input>
                        </div>
                        <!-- 历史记录的邮件号 -->
                        <div class="history" v-if="historicalData.length != 0">
                            <span class="history_title"
                                >Recently Tracked Number:</span
                            >
                            <div
                                class="historicalRecord"
                                v-for="(item, index) in historicalData"
                                :key="index"
                            >
                                <span
                                    class="historicalRecordSpan"
                                    @click="copyHistory(index)"
                                    >{{ item }}</span
                                >
                            </div>
                        </div>
                        <div
                            class="errorList onlyErrorRed"
                            :class="[
                                {
                                    mo: historicalData.length == 0,
                                    mos: !historicalData.length == 0,
                                },
                            ]"
                            v-if="this.messageerBox != ''"
                        >
                            <span><img v-lazy="img[0]" /></span>
                            <span class="error_mag">{{
                                this.messageerBox
                            }}</span>
                        </div>
                    </div>
                </div>

                <!--   @click="toLog"-->
                <div data-tooltip="Stay Tuned" class="div-style">
                    <div class="btn-blue onlyBackgroundBlule">
                        <svg
                            class="icon"
                            width="42px"
                            height="38px"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M942.933333 618.666667l-38.4-38.4 29.866667-29.866667L1024 640l-89.6 89.6-29.866667-29.866667 38.4-38.4h-196.266666v-42.666666h196.266666zM409.6 473.6l123.733333 72.533333 294.4-170.666666-128-72.533334-290.133333 170.666667z m-42.666667-21.333333l294.4-170.666667-128-72.533333-294.4 170.666666 128 72.533334zM213.333333 413.866667v260.266666l298.666667 170.666667v-260.266667l-298.666667-170.666666z m640 0l-298.666666 170.666666v260.266667l217.6-123.733333 38.4 29.866666-277.333334 157.866667L170.666667 699.733333V366.933333l362.666666-209.066666L896 366.933333V554.666667h-42.666667V413.866667z"
                            />
                        </svg>
                        <span class="el-menu-demo-font2">Shipping</span>
                    </div>
                </div>
                <div data-tooltip="Stay Tuned" class="div-style">
                    <div class="btn-blue onlyBackgroundBlule">
                        <svg
                            class="icon"
                            width="26px"
                            height="26px"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M511.970818 0a511.970818 511.970818 0 0 0 0 1023.941635 32.45895 32.45895 0 0 0 3.890978 0 32.45895 32.45895 0 0 0 3.890978 0h444.697852a38.807388 38.807388 0 0 0 27.032059-66.556206l-186.152589-181.032881a38.756191 38.756191 0 1 0-54.064118 55.600031l117.753288 114.425477h-349.164098a32.45895 32.45895 0 0 0-3.890978 0 32.45895 32.45895 0 0 0-3.890978 0 434.048859 434.048859 0 1 1 426.3181-350.648813 38.807388 38.807388 0 1 0 76.181257 14.847154A512.482788 512.482788 0 0 0 511.970818 0zM530.196979 856.578375a40.957665 40.957665 0 0 0 40.650483-40.650483v-105.721974h111.097667a40.650483 40.650483 0 0 0 0-81.300966h-111.097667v-70.447184h108.384222a40.70168 40.70168 0 0 0 0-81.352163h-108.742602a36.503519 36.503519 0 0 0 5.119708-4.454146l134.136355-134.136354a40.650483 40.650483 0 0 0-57.494323-57.494323l-122.309829 122.361025-127.992704-127.992704a40.650483 40.650483 0 0 0-57.033549 57.699111l134.136354 134.136354a40.292103 40.292103 0 0 0 16.280672 9.881037H381.111077a40.70168 40.70168 0 0 0 0 81.352163h108.435419v70.447184H383.978113a40.650483 40.650483 0 0 0 0 81.300966h105.568383v105.721974a40.957665 40.957665 0 0 0 40.650483 40.650483zM522.619811 476.13286l1.126335 0.767957h-3.430204c0.767956 0 1.535912-0.307182 2.303869-0.767957z"
                            />
                        </svg>

                        <span
                            class="el-menu-demo-font2"
                            data-tooltip="Stay Tuned"
                            >Rates & Transit Time</span
                        >
                    </div>
                </div>

                <div data-tooltip="Stay Tuned" class="div-style">
                    <div class="btn-blue onlyBackgroundBlule">
                        <svg
                            class="icon"
                            width="28px"
                            height="28px"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1017.6 889.6c-6.4-12.8-6.4-19.2-6.4-19.2l-121.6-236.8-6.4-6.4-6.4-6.4c-12.8-19.2-25.6-44.8-57.6-44.8h-128c-19.2 0-25.6 12.8-25.6 25.6s12.8 25.6 25.6 25.6h128s6.4 6.4 12.8 19.2l6.4 6.4 121.6 217.6s-6.4 6.4-12.8 6.4h-870.4s-6.4 0-6.4-6.4l128-217.6s6.4-6.4 6.4-12.8 6.4-6.4 0-6.4h115.2c19.2 0 25.6-12.8 25.6-25.6s-12.8-25.6-25.6-25.6h-115.2c-32 0-44.8 19.2-51.2 32l-6.4 6.4s-6.4 6.4-6.4 12.8l-134.4 230.4v12.8c0 38.4 32 64 70.4 64h870.4c32 6.4 70.4-12.8 70.4-51.2zM512 403.2c70.4 0 128-57.6 128-128s-57.6-128-128-128-128 57.6-128 128 57.6 128 128 128z m0-198.4c38.4 0 70.4 32 70.4 70.4-6.4 38.4-38.4 70.4-70.4 70.4-38.4 0-70.4-32-70.4-70.4 0-38.4 32-70.4 70.4-70.4zM441.6 684.8c25.6 32 44.8 44.8 70.4 44.8s44.8-12.8 70.4-44.8c70.4-76.8 160-185.6 192-307.2 25.6-83.2 6.4-172.8-44.8-249.6-51.2-64-134.4-102.4-217.6-102.4-96 0-172.8 38.4-230.4 102.4-51.2 64-64 160-32 249.6 25.6 83.2 89.6 192 192 307.2z m-115.2-524.8c32-51.2 96-76.8 179.2-76.8 64 0 128 32 166.4 83.2 44.8 57.6 64 134.4 44.8 198.4-32 115.2-115.2 217.6-185.6 281.6l-25.6 25.6s-6.4-6.4-6.4-12.8c-6.4-6.4-6.4-12.8-12.8-12.8l-12.8-12.8c-44.8-51.2-140.8-166.4-172.8-275.2-19.2-70.4-12.8-140.8 25.6-198.4z"
                            />
                        </svg>
                        <span
                            class="el-menu-demo-font2"
                            data-tooltip="Stay Tuned"
                            >Services Points</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="
                isWaybillsQuery &&
                waybillsMessageer ==
                    'Query result temporarily unavailable for the item！'
            "
            style="color: red; text-align: center; padding-top: 1.5rem"
        >
            {{ waybillsMessageer }}
        </div>
        <CaptchaText
            ref="captchaRef"
            :visible.sync="showSlide"
            @updateCid="capcodeData = $event"
            @success="handleSuccess"
        ></CaptchaText>
    </div>
</template>
<script>
//import SlideVerify from "@/components/slide-verify";
import CaptchaText from "@/components/english/CaptchaText";
import moment from "moment";
import md5 from "js-md5";
import commonApi from "@/server/common";
let Base64 = require("js-base64").Base64;
export default {
    name: "Swiper",
    data() {
        return {
            img: [
                require("../../../assets/english-images/home_page_img/xinghao2.png"),
            ],
            phonePrompt: "Enter your waybill number",
            status: false, // 登录的状态
            imgList: [],
            input: "",
            isFocus: false,
            isclick: false,
            showSlide: false,
            spans: "",
            messageerBox: "",
            allData: [],
            selectedOrderIdx: "", //双击选中的运单号的索引
            historicalData: [],
            loginTimer: null,
            loginTimerT: null,
            num: "",
            bannerHeight: "", //轮播图的高度
            codeErrorTip: false,
            capcodeData: "",
            isWaybillsQuery: false, //是否外部查询
            waybills: "", //外部查询邮件号
            waybills_no: [], //外部查询邮件号数组,
            waybillsMessageer: "", //外部查询错误提示,
        };
    },
    components: {
        CaptchaText,
    },
    mounted() {
        if (this.$route.name && this.$route.name == "waybills_query") {
            this.isWaybillsQuery = true;
            if (this.$route.query.token) {
                this.waybills = this.$route.query.token;
                this.waybills = this.waybills.replace(/[^\w]|_/g, "");
                this.waybills = this.waybills.toUpperCase();
                this.waybills_no.push(this.waybills);
            }
            this.getImageVerifyCode();
        } else {
            this.bannerHeight = "573";
            window.addEventListener(
                "resize",
                () => {
                    this.imgLoad();
                },
                false
            );
            this.init();
        }
    },
    props: ["shouyecode", "name"],
    methods: {
        handleLoad() {
            this.imgLoad();
        },
        imgLoad() {
            this.$nextTick(() => {
                this.bannerHeight =
                    this.$refs.bannerHeight && this.$refs.bannerHeight.length
                        ? this.$refs.bannerHeight[0].height
                        : ""; //关键的一步
            });
        },
        linkTo(val) {
            if (this.isclick) {
                this.$axios
                    .post("/leafletStatistics/getLeafletStatistics", {
                        value: {
                            adId: val,
                            logType: "1",
                            adUrl: this.imgList[val].productionImgUrl,
                        },
                    })
                    .then((res) => {})
                    .catch((err) => {});
            }
        },
        // 判断是否登录
        isLogin() {
            // 已经登录
            if (localStorage.getItem("sta_tus") == "false") {
                // console.log("没有登录");
                this.status = false;
                this.phonePrompt = "Enter your tracking number";
            } else {
                // console.log("已经登陆了");
                this.status = true;
                this.phonePrompt = "请输入邮件号或手机号进行查询";
            }
        },
        toggleInputNode(idx) {
            this.selectedOrderIdx = idx;
            this.$nextTick(() => {
                const input = this.$refs.order_input
                    ? this.$refs.order_input[0]
                    : null;
                input && input.select();
            });
        },
        checkApple(data) {
            this.showSlide = false;
            // window.open("/pc/login/index?_url=L3F1ZXJ5TGlzdD90YWI9MQ==&from=emsnew");
            window.open("https://www.ems.com.cn/apple/query/" + data);
        },
        /**
         * 数组去重复
         */
        toRepeat(arr) {
            if (!Array.isArray(arr)) {
                // console.log("type error!");
                return;
            }
            var array = [];
            for (var i = 0; i < arr.length; i++) {
                if (array.indexOf(arr[i]) === -1) {
                    array.push(arr[i]);
                }
            }
            return array;
        },
        delet(index) {
            if (index == 0) {
                this.messageerBox = "";
            }
            this.allData.splice(index, 1);
        },
        // 查询按钮
        routerLink1() {
            if (this.input == "") {
                this.messageerBox = "Please enter your tracking number.";
            } else if (this.input.length < 8 || this.input.length > 26) {
                this.messageerBox = "Tracking number error, please re-enter!";
            } else {
                this.input = this.input.toUpperCase();
                this.input = this.input.trim();
                this.getImageVerifyCode();
                this.messageerBox = "";
            }
        },

        getImageVerifyCode() {
            this.showSlide = true;
        },

        // 刷新
        onRefresh() {
            this.getImageVerifyCode();
        },

        // 校验成功的方法
        handleSuccess(left) {
            this.distance = left;
            let queryData = {
                value: {
                    customerIP: returnCitySN["cip"],
                    phoneNum: localStorage.getItem("phone"),
                    waybillNoList: this.isWaybillsQuery
                        ? this.waybills_no
                        : [this.input],
                    trackList: this.distance,
                    capcode: this.capcodeData,
                    enFlag: "1",
                },
            };
            // this.obtainHistoryOne();
            this.flagQuery(queryData);
        },

        getTimestamp() {
            return this.$axios.post("/currentTime/queryTime");
        },
        /**
         * 先校验是什么格式的
         * @param  queryData  --传递过来的参数
         */
        async flagQuery(queryData) {
            //已确认
            let waybillNoList = queryData.value.waybillNoList.join("");
            let { value: nowTime } = await this.getTimestamp();
            nowTime = nowTime.toString();
            let timeThree = nowTime.substring(0, 3);
            let timeTen = nowTime.substring(nowTime.length - 10);
            let key = "1163FA15CC9A425EA4B65B2A218FF5F8";
            let capcode = queryData.value.capcode;
            let md5Data = waybillNoList + timeThree + key + timeTen + capcode;

            md5(md5Data).toUpperCase();
            let oneMd5 = md5(md5Data).toUpperCase();
            let twoMd5 = md5(oneMd5).toUpperCase();
            Base64.encode(twoMd5);
            let ticket = Base64.encode(twoMd5);

            // 物流的
            commonApi
                .getLogisticsTestFlag(queryData, {
                    headers: { time: nowTime, ticket: ticket },
                })
                .then((res) => {
                    if (res.value.flagGetInfo == "1") {
                        this.countryQuery(res);
                        // this.getTheSame("error");
                    } else if (res.value.flagGetInfo == "2") {
                        this.logisticsQuery(res);
                        // this.getTheSame("error");
                    } else if (res.value.flagGetInfo == "3") {
                        this.appleDetails(res);
                        // this.getTheSame("error");
                    } else if (res.value.flagGetInfo == "4") {
                        this.listQuery(res);
                    }
                })
                .catch((err) => {
                    if (
                        err.data.message == "Please enter the mail to query.rey"
                    ) {
                        this.showSlide = false;
                        this.$router.push({
                            path: "/",
                        });
                    } else {
                        this.onRefresh();
                        this.messageerBox = err.data.message;
                    }
                });
        },
        getTheSame(n) {
            if (n == "error") {
                this.obtainHistoryOne([this.input]);
            } else {
                let arr1 = JSON.parse(JSON.stringify(this.allData)); //数组A
                let arr2 = JSON.parse(JSON.stringify(n)); //数组B
                let temp = []; //临时数组1
                let temparray = []; //临时数组2
                for (let i = 0; i < arr2.length; i++) {
                    temp[arr2[i]] = true; //巧妙地方：把数组B的值当成临时数组1的键并赋值为真
                }
                for (let i = 0; i < arr1.length; i++) {
                    if (!temp[arr1[i]]) {
                        temparray.push(arr1[i]);
                        //巧妙地方：同时把数组A的值当成临时数组1的键并判断是否为真，如果不为真说明没重复，就合并到一个新数组里，这样就可以得到一个全新并无重复的数组
                    }
                }
                this.obtainHistoryOne(temparray);
            }
        },
        /**
         * 国内单个的查询，直接跳转到单个的gis地图的页面
         * @param  queryData  --传递过来的参数
         */
        async countryQuery(res) {
            // 原本路由的传参方式
            // 现有的利用缓存的方式存储数据
            // if(res.value.notConforming == undefined) {
            // 现有的利用缓存的方式存储数据

            let waybillNoList = res.value.list[0].list.join("");
            let { value: nowTime } = await this.getTimestamp();
            nowTime = nowTime.toString();
            let timeThree = nowTime.substring(0, 3);
            let timeTen = nowTime.substring(nowTime.length - 10);
            let key = "44FC5D74924447C1A9ABC8FD011CF9A0";
            let capcode = this.capcodeData;
            let md5Data = waybillNoList + timeThree + key + timeTen + capcode;

            md5(md5Data).toUpperCase();
            let oneMd5 = md5(md5Data).toUpperCase();
            let twoMd5 = md5(oneMd5).toUpperCase();
            Base64.encode(twoMd5);
            let ticket = Base64.encode(twoMd5);

            let wuliu = {
                value: [
                    {
                        ip: returnCitySN["cip"],
                        trackList: this.distance,
                        capcode: this.capcodeData,
                        mailStatus: "a", //a  b
                        orderNum: res.value.list[0].list, //单号
                        orderType: "1", //1  2  3
                        noRulesNum: [],
                        // 新家的字段
                        appleFlag: null,
                    },
                ],
                list: res.value.list[0].list,
            };
            commonApi
                .queryTrack(wuliu, {
                    headers: { time: nowTime, ticket: ticket },
                })
                .then((data) => {
                    this.getTheSame("error");
                    // localStorage.setItem("id", JSON.stringify(res.value.list[0].list));
                    // localStorage.setItem("mailStatus", res.value.list[0].mailStatus);
                    // localStorage.setItem("flag", res.value.list[0].flag);
                    // localStorage.setItem("message", "country");
                    // localStorage.setItem("capcode", this.capcodeData);
                    // 邮编号存到缓存里面
                    localStorage.setItem("queryLog", JSON.stringify(data));
                    this.$router.push({
                        name: "queryLogistics",
                    });
                })
                .catch((err) => {
                    this.messageerBox = err.data.message;
                    this.waybillsMessageer = err.data.message;
                    if (this.messageerBox == "Validation failed!") {
                        this.onRefresh();
                    } else {
                        this.showSlide = false;
                    }
                });
        },
        /**
         * 物流的查询
         * @param  queryData  --传递过来的参数
         */
        async logisticsQuery(res) {
            let waybillNoList = res.value.list[0].list.join("");
            let { value: nowTime } = await this.getTimestamp();
            nowTime = nowTime.toString();
            let timeThree = nowTime.substring(0, 3);
            let timeTen = nowTime.substring(nowTime.length - 10);
            let key = "2A9523AF0F16463EA25843481239F4B0";
            let capcode = this.capcodeData;
            let md5Data = waybillNoList + timeThree + key + timeTen + capcode;

            md5(md5Data).toUpperCase();
            let oneMd5 = md5(md5Data).toUpperCase();
            let twoMd5 = md5(oneMd5).toUpperCase();
            Base64.encode(twoMd5);

            let ticket = Base64.encode(twoMd5);

            let wuliu = {
                value: [
                    {
                        ip: returnCitySN["cip"],
                        trackList: this.distance,
                        capcode: this.capcodeData,
                        mailStatus: res.value.list[0].mailStatus, //a  b
                        orderNum: res.value.list[0].list, //单号
                        orderType: res.value.list[0].flag, //1  2  3
                        // 新家的字段
                        noRulesNum: [],
                        appleFlag: null,
                    },
                ],

                list: res.value.list[0].list,
            };
            commonApi
                .mixedQuery(wuliu, {
                    headers: { time: nowTime, ticket: ticket },
                })
                .then((data) => {
                    this.getTheSame("error");
                    // console.log("成功");
                    this.$router.push({
                        name: "Logistics",
                        params: {
                            id: JSON.stringify(res.value.list[0].list),
                            mailStatus: res.value.list[0].mailStatus,
                            flag: res.value.list[0].flag,
                        },
                    });
                })
                .catch((err) => {
                    // console.log("失败");
                    // 校验如果是手机号的话就跳页面
                    // localStorage.setItem("current", "1");
                    this.messageerBox = err.data.message;

                    let re = /^1\d{10}$/;
                    if (re.test(this.allData[0])) {
                        // console.log("手机号");
                        window.open("/pc/login/index?_url=Lw==&from=emsnew");
                    }
                });
        },
        /**
         * 苹果的单个
         * @param  queryData  --传递过来的参数
         */
        async appleDetails(res) {
            // 如果没有错误的邮件号直接跳转到单个页面
            if (res.value.notConforming == undefined) {
                // console.log("jinru");
                // 判断是单个还是多个的
                if (res.value.list[0].mailStatus == "b") {
                    let waybillNoList = res.value.list[0].list.join("");
                    let { value: nowTime } = await this.getTimestamp();
                    nowTime = nowTime.toString();
                    let timeThree = nowTime.substring(0, 3);
                    let timeTen = nowTime.substring(nowTime.length - 10);
                    let key = "1163FA15CC9A425EA4B65B2A218FF5F8";
                    let capcode = this.capcodeData;
                    let md5Data =
                        waybillNoList + timeThree + key + timeTen + capcode;

                    md5(md5Data).toUpperCase();
                    let oneMd5 = md5(md5Data).toUpperCase();
                    let twoMd5 = md5(oneMd5).toUpperCase();
                    Base64.encode(twoMd5);
                    let ticket = Base64.encode(twoMd5);

                    let wuliu = {
                        value: [
                            {
                                trackList: this.distance,
                                capcode: this.capcodeData,
                                mailStatus: res.value.list[0].mailStatus, //a  b
                                orderNum: res.value.list[0].list, //单号
                                orderType: res.value.list[0].flag, //1  2  3
                                noRulesNum: [],
                                // 新家的字段
                                appleFlag: null,
                            },
                        ],
                        list: res.value.list[0].list,
                    };
                    commonApi
                        .mixedQuery(wuliu, {
                            headers: { time: nowTime, ticket: ticket },
                        })
                        .then((data) => {
                            // console.log("第一遍调用了");
                            // 如果输入的长度是一条的则需要自己判断
                            if (this.allData.length == 1) {
                                // 判断每一条的traceNo是否一样，如果一样的话则跳转到单个页面，如果不一样的话则跳转到列表页面
                                let appRepeat = [];
                                for (
                                    let i = 0;
                                    i < data.value[0][1][0].length;
                                    i++
                                ) {
                                    appRepeat.push(
                                        data.value[0][1][0][i].traceNo
                                    );
                                }
                                let appRepeatList = this.toRepeat(appRepeat);
                                if (appRepeatList.length == 1) {
                                    this.getTheSame("error");
                                    localStorage.setItem(
                                        "id",
                                        JSON.stringify(res.value.list[0].list)
                                    );
                                    localStorage.setItem(
                                        "mailStatus",
                                        res.value.list[0].mailStatus
                                    );
                                    localStorage.setItem(
                                        "flag",
                                        res.value.list[0].flag
                                    );
                                    localStorage.setItem("message", "apple");
                                    this.$router.push({
                                        name: "queryLogistics",
                                    });
                                } else {
                                    // 跳转到批量的
                                    let code_id = this.allData;
                                    this.$router.push({
                                        name: "queryList",
                                        params: {
                                            tab: "0",
                                            code_id: code_id,
                                            xpos: JSON.stringify(this.distance),
                                            capcode: this.capcodeData,
                                        },
                                    });
                                }
                            } else {
                                // 如果不是的话则不需要自己判断
                                let code_id = this.allData;
                                this.$router.push({
                                    name: "queryList",
                                    params: {
                                        tab: "0",
                                        code_id: code_id,
                                        xpos: JSON.stringify(this.distance),
                                        capcode: this.capcodeData,
                                    },
                                });
                            }
                        })
                        .catch((err) => {
                            this.messageBox = err.data.message;
                        });
                } else {
                    this.checkApple(res.value.list[0].list[0]);
                    // 单个的
                }
                // 现有的利用缓存的方式存储数据
            } else if (res.value.notConforming.length > 0) {
                this.$router.push({
                    name: "queryList",
                    params: {
                        tab: "0",
                        code_id: this.allData,
                        xpos: JSON.stringify(this.distance),
                        capcode: this.capcodeData,
                    },
                });
            }
        },
        /**
         * 批量的查询
         * @param  queryData  --传递过来的参数
         */
        listQuery(res) {
            let code_id = this.allData;
            this.$router.push({
                name: "queryList",
                params: {
                    tab: "0",
                    code_id: code_id,
                    xpos: JSON.stringify(this.distance),
                    capcode: this.capcodeData,
                },
            });
        },
        blurHandle() {
            if (this.allData.length > 0 || this.input > 0) {
                // this.messageerBox = ""
            }
            if (this.input == "") {
                // this.messageerBox = "";
            }
            setTimeout(() => {
                this.isFocus = false;
            }, 300);
        },

        toLog() {
            // 外网
            // 判断是否登录
            if (this.status == false) {
                // 没有登录
                // console.log("没有登录");
                this.loginTimerOut();
                window.open("/pc/main/new/#/order/v2/index?product=M7lr1yKQ");
            } else {
                window.open("/pc/main/new/#/order/v2/index?product=M7lr1yKQ");
            }

            var Traffic = {
                value: {
                    ip: returnCitySN["cip"],
                    area: returnCitySN["cname"],
                    cookies: this.$cookies.get("ecun"),
                    modelPath: "pc/order/product",
                    modelName: Base64.encode("我要寄件"),
                    createData: moment().format("YYYY-MM-DD HH:mm:ss"),
                    onlineTime: "",
                    phonePcFlag: this.$store.state.message,
                },
            };
            this.$axios
                .post(
                    "/userTrafficStatistics/getUserTrafficStatistics",
                    Traffic
                )
                .then((res) => {})
                .catch((err) => {});
        },

        loginTimerOut() {
            this.loginTimer = setTimeout(() => {
                localStorage.setItem("num", "2");
                this.$router.go(0);
            }, 10000);
        },
        loginTimerOutT() {
            this.loginTimerT = setTimeout(() => {
                localStorage.setItem("num", "1");
                this.$router.go(0);
            }, 20000);
        },
        // 去登录
        toLogin() {
            let loginStatus = {
                value: {
                    rout: "/#/",
                },
            };
            this.$axios
                .post("/loginJump/getLoginJump", loginStatus)
                .then((res) => {
                    window.location.href = res.value.encryption;
                })
                .catch((err) => {
                    this.$message.error(err.data.message);
                });
        },
        init() {
            let imgListData = {
                value: this.shouyecode,
            };
            this.$axios
                .post("/rollPic/showRollPic", imgListData)
                .then((res) => {
                    this.imgList = res.value.imgList;
                })
                .catch((err) => {
                    this.$message.error(err.data.message);
                });
            // 获取缓存的历史记录邮件号
            this.obtainHistory();
            this.isLogin();
            this.num = localStorage.getItem("num");
            if (this.num == "1") {
            } else if (this.num == "2") {
                this.loginTimerOutT();
            }
        },

        clickBuy(item) {
            if (item.site) {
                window.open(item.site);
            }
        },
        /**
         * 初始化获取历史记录邮件号
         */
        obtainHistory() {
            if (
                this.$cookies.get("englishHistorD") == "" ||
                this.$cookies.get("englishHistorD") == undefined
            ) {
            } else {
                this.historicalData = JSON.parse(
                    this.$cookies.get("englishHistorD")
                );
            }
        },
        /**
         * 历史记录赋值到alldata中
         */
        copyHistory(index) {
            console.log(index);
            // if(this.allData.length <= 19) {
            // this.allData.push(this.historicalData[index]);
            // this.allData = this.toRepeat(this.allData);
            this.input = this.historicalData[index];
            // } else {
            // 	this.messageBox = "最多输入20条";
            // }
        },
        /**
         * 查询的结果赋值历史记录
         */
        obtainHistoryOne(temparray) {
            if (temparray.length == 3) {
                this.historicalData = [];
                this.historicalData = JSON.parse(JSON.stringify(temparray));
                this.$cookies.set(
                    "englishHistorD",
                    JSON.stringify(this.historicalData)
                );
            } else if (temparray.length < 4) {
                if (this.historicalData.length < 3) {
                    for (let i = 0; i < temparray.length; i++) {
                        this.historicalData.push(temparray[i]);
                    }
                    this.historicalData = this.toRepeat(this.historicalData);
                    if (this.historicalData.length > 3) {
                        this.historicalData.splice(
                            0,
                            this.historicalData.length - 3
                        );
                    }
                    this.$cookies.set(
                        "englishHistorD",
                        JSON.stringify(this.historicalData)
                    );
                } else {
                    if (temparray.length <= 3) {
                        for (let i = 0; i < temparray.length; i++) {
                            this.historicalData.push(temparray[i]);
                        }
                        this.historicalData = this.toRepeat(
                            this.historicalData
                        );
                        if (this.historicalData.length > 3) {
                            this.historicalData.splice(
                                0,
                                this.historicalData.length - 3
                            );
                        }
                    }
                    this.$cookies.set(
                        "englishHistorD",
                        JSON.stringify(this.historicalData)
                    );
                }
            } else if (temparray.length >= 4) {
                this.historicalData = [];
                for (let i = 0; i < 3; i++) {
                    this.historicalData.push(temparray[i]);
                }
                this.$cookies.set(
                    "englishHistorD",
                    JSON.stringify(this.historicalData)
                );
            }
        },
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                // console.log(val);
            },
            // 深度观察监听
            deep: true,
        },
    },
};
</script>

<style lang="scss">
#tou {
    width: 100%;
    height: auto;
    img {
        width: 100%;
        height: auto;
    }
}

.div-style {
    position: relative;
    display: inline-block;
}
.div-style:hover {
    cursor: pointer;
}
.div-style:hover:before {
    content: attr(data-tooltip);
    background: #004b9c;
    color: #ffffff;
    text-align: center;
    font-size: 16px;
    padding: 0.8em 1em;
    width: 240px;
    height: 50px;
    line-height: 50px;
    position: absolute;
    left: -1%;
    top: -100%;
    margin-left: 14px;

    white-spack: pre;
}
.div-style:hover:after {
    content: " ";
    position: absolute;
    left: 80%;
    width: 0;
    height: 0;
}

@import "../../../assets/css/english-css/swiper/swiper.scss";
</style>
